import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

// authService.redirectOnLoad$ redirects an authenticated user that has not verified their email to the /email-not-verified route
// You should not be able to access that page if you are not authenticated
export const verifyEmailGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.firebaseUser$.pipe(
    take(1),
    map((user) => {
      if (user) {
        if (user.emailVerified) {
          // user is authenticated and verified - route to dashboard
          router.navigate(['/dashboard']);
          return false;
        } else {
          // user is authenticated but email is not verified - allow access
          return true;
        }
      } else {
        // user is not authenticated, redirect to sign-in
        // can't send email verification link to unauthenticated user
        router.navigate(['/sign-in']);
        return false;
      }
    }),
  );
};
